// loaderManager.js - Manages pending requests count, loader state, and error messages
let pendingRequests = 0;
let loadingStateCallback = null;
let errorCallbacks = [];

// Subscribe to loading state changes
export const subscribeToLoadingState = callback => {
  loadingStateCallback = callback;
  // Immediately notify the current state
  callback(pendingRequests > 0);

  // Return unsubscribe function
  return () => {
    loadingStateCallback = null;
  };
};

// Subscribe to error messages
export const subscribeToErrors = callback => {
  errorCallbacks.push(callback);

  // Return unsubscribe function
  return () => {
    errorCallbacks = errorCallbacks.filter(cb => cb !== callback);
  };
};

// Update the loading state
const updateLoadingState = isLoading => {
  if (loadingStateCallback) {
    loadingStateCallback(isLoading);
  }
};

// Report an error
const reportError = (errorMessage, errorDetails = null) => {
  errorCallbacks.forEach(callback => {
    try {
      callback(errorMessage, errorDetails);
    } catch (err) {
      console.error('Error in error callback:', err);
    }
  });
};

// Increment pending requests count
export const incrementPendingRequests = () => {
  pendingRequests++;
  if (pendingRequests === 1) {
    updateLoadingState(true);
  }
};

// Decrement pending requests count
export const decrementPendingRequests = () => {
  pendingRequests = Math.max(0, pendingRequests - 1);
  if (pendingRequests === 0) {
    updateLoadingState(false);
  }
};

// Report an error message
export const reportErrorMessage = (errorMessage, errorDetails = null) => {
  reportError(errorMessage, errorDetails);
};

// Get current pending requests count
export const getPendingRequestsCount = () => {
  return pendingRequests;
};
